import styled from '@emotion/styled';
import { FC, ReactNode } from 'react';
import { theme } from '../../theme';
import { ReactComponent as DeprecatedChevronUpIcon } from '../../assets/icons/DeprecatedChevronUpIcon.svg';
import { ReactComponent as DeprecatedChevronDownIcon } from '../../assets/icons/DeprecatedChevronDownIcon.svg';
import { TableBodyCell } from './TableBodyCell';

type Props = {
  children: ReactNode;
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
};

const ExpandedStyledTd = styled(TableBodyCell)`
  cursor: pointer;
  color: ${theme.colors.iconAction.primary};

  &:hover {
    color: ${theme.colors.actionPrimary.hover};

    svg path {
      fill: ${theme.colors.actionPrimary.hover};
    }
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TableBodyCellExpandable: FC<Props> = ({ children, isExpanded, setIsExpanded }) => {
  const ChevronIcon = isExpanded ? DeprecatedChevronUpIcon : DeprecatedChevronDownIcon;

  return (
    <ExpandedStyledTd onClick={() => setIsExpanded(!isExpanded)}>
      <Content>
        {children}
        <ChevronIcon style={{ paddingLeft: theme.spacing.d }} />
      </Content>
    </ExpandedStyledTd>
  );
};
